<div class="full-view-bg">
  <app-flag-manager-top-bar
    [group]="group"
    [countTabs]="tabsCount"
    [selectedTab]="selectedTab"
    [underwritingStatus]="underwritingStatus"
    [allFlags]="allFlags"
    [issueNo]="issueNo"
    (tabChanged)="onTabChanged($event)"
    [currentFlags]="currentFlags"
    (editGroup)="editGroup.emit($event)"></app-flag-manager-top-bar>

  <app-flag-resolve-topbar
    *ngIf="shouldShowResolveTopbar()"
    [totalFlags]="getTotalResolvableFlags()"
    [resolvedFlags]="resolved.length"
    [unresolvedCount]="unResolved.length"
    [partialResponseCount]="partialResponse.length"
    [resolveBarSelectedTab]="resolveBarSelectedTab"
    [selectedTab]="getResolveSelectedTab()"
    (tabChange)="onResolveTabChange($event)">
  </app-flag-resolve-topbar>

  <div class="full-view-flags">
    <app-flag-image-section
      [showResolveOptions]="shouldShowResolveTopbar()"
      [flags]="showableFlags"
      [inspection]="inspection"
      [resolveBarSelectedTab]="resolveBarSelectedTab"
      (selectedFlagsChange)="onSelectedFlagsChange($event)"
      (statusChange)="onFlagStatusChange($event)"
      (flagIgnored)="onFlagIgnored($event)"
      [selectedTab]="selectedTab">
    </app-flag-image-section>
  </div>
</div>
